export type UpdateStatus = Record<string, never>;

export const UpdateStatusActions = {} as const;
